export const getFileColumns = (translate, isSubUser) => {
  return isSubUser
    ? [
        {
          key: "file",
          text: translate("File"),
        },
        {
          key: "documents",
          text: translate("Documents"),
        },
        {
          key: "flow",
          text: translate("Flow"),
        },
        {
          key: "flowName",
          text: translate("flowName"),
        },
        {
          key: "channels",
          text: translate("Channels"),
        },
        {
          key: "arrivalTime",
          text: translate("ArrivalTime"),
        },
        {
          key: "completionTime",
          text: translate("CompletionTime"),
        },
        {
          key: "status",
          text: translate("Status"),
        },
      ]
    : [
        {
          key: "customer",
          text: translate("Customer"),
        },
        {
          key: "platform",
          text: translate("Platform"),
        },
        {
          key: "file",
          text: translate("File"),
        },
        {
          key: "documents",
          text: translate("Documents"),
        },
        {
          key: "flow",
          text: translate("Flow"),
        },
        {
          key: "flowName",
          text: translate("flowName"),
        },
        {
          key: "channels",
          text: translate("Channels"),
        },
        {
          key: "errors",
          text: translate("Errors/Incidents"),
        },
        {
          key: "arrivalTime",
          text: translate("ArrivalTime"),
        },
        {
          key: "completionTime",
          text: translate("CompletionTime"),
        },
        {
          key: "status",
          text: translate("Status"),
        },
      ];
};
